const FETCH_REALISATIONS = 'realisations/FETCH_REALISATIONS';

export default function showRealisations(state = {}, action) {
    switch (action.type) {
        case FETCH_REALISATIONS:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            };
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./redux/reducers/realisations.js